import { Component, Input, OnInit, TemplateRef } from "@angular/core";
import { EdCardComponent } from "@edenred/components/card";
import { NgIf, NgTemplateOutlet } from "@angular/common";
import {
  animate,
  state,
  style,
  transition,
  trigger,
} from "@angular/animations";
import { MatIconModule } from "@angular/material/icon";
import { EdButtonComponent } from "@edenred/components/button";
import { EdTooltipComponent } from "@edenred/components/tooltip";
import { TranslocoPipe } from "@jsverse/transloco";

@Component({
  selector: "er-card-collapse",
  templateUrl: "./card-collapse.component.html",
  styleUrls: ["./card-collapse.component.scss"],
  imports: [
    EdCardComponent,
    NgIf,
    NgTemplateOutlet,
    MatIconModule,
    EdButtonComponent,
    EdTooltipComponent,
    TranslocoPipe,
  ],
  animations: [
    trigger("expand", [
      state(
        "collapsed",
        style({
          height: "0",
          opacity: 0,
          overflow: "hidden",
        }),
      ),
      state(
        "expanded",
        style({
          height: "*",
          opacity: 1,
          overflow: "hidden",
        }),
      ),
      transition("collapsed <=> expanded", [animate("300ms ease-in-out")]),
    ]),
  ],
  standalone: true,
})
export class CardCollapseComponent implements OnInit {
  @Input({ required: true })
  public title!: string;
  @Input()
  public subtitle = "";
  @Input({ required: true })
  public content!: TemplateRef<void>;
  @Input()
  public redirectUrl: string | undefined = undefined;
  @Input()
  public redirectUrlDisplayText: string | undefined = undefined;
  @Input()
  public id: string | undefined = undefined;
  @Input()
  public expanded?: boolean = false;
  @Input()
  public disabled = false;
  @Input()
  public tooltipText!: string | undefined;

  public isContentCollapsed: boolean | true = true;

  public ngOnInit(): void {
    if (this.expanded) {
      this.displayContent();
    }
  }

  public toggleContent(): void {
    if (this.isContentCollapsed) {
      this.displayContent();
    } else {
      this.hideContent();
    }
  }

  public displayContent(): void {
    this.isContentCollapsed = false;
  }

  public hideContent(): void {
    this.isContentCollapsed = true;
  }

  public get displayId(): boolean {
    return this.id !== undefined && this.id?.trim().length > 0;
  }

  public expandContent() {
    if (this.isContentCollapsed) {
      this.displayContent();
    }
  }
}
